var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxPatterns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 856,
    viewBox: "0 0 1440 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1803 -41.1978H-20.8397L-4.90972 -13.7809L-2.04972 -8.86787L3.47028 0.63502L31.8003 49.3749L50.1203 80.9026H130.32L56.1803 -41.1978Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.45 202.981H120.43L136.36 175.575L139.22 170.662L144.74 161.159L173.07 112.408L191.39 80.9026H271.6L197.45 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3002 202.981L-30.1598 80.9026H50.0502L68.2202 112.408L106.14 178.193L120.43 202.981H43.3002Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.34 -41.1978H422.32L438.25 -13.7809L441.11 -8.86787L446.63 0.63502L474.96 49.3749L493.27 80.9026H573.48L499.34 -41.1978Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.19 -41.1978L271.73 80.9026H351.93L370.1 49.3749L408.03 -16.3989L422.32 -41.1978H345.19Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M640.61 202.981H563.59L579.52 175.575L582.38 170.662L587.9 161.159L616.23 112.408L634.54 80.9026H714.75L640.61 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M486.46 202.981L413 80.9026H493.2L511.37 112.408L549.3 178.193L563.59 202.981H486.46Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M942.491 -41.1978H865.471L881.401 -13.7809L884.261 -8.86787L889.781 0.63502L918.111 49.3749L936.431 80.9026H1016.64L942.491 -41.1978Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M788.34 -41.1978L714.88 80.9026H795.09L813.26 49.3749L851.18 -16.3989L865.47 -41.1978H788.34Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.76 202.981H1006.74L1022.67 175.575L1025.53 170.662L1031.06 161.159L1059.38 112.408L1077.7 80.9026H1157.91L1083.76 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M929.61 202.981L856.15 80.9026H936.36L954.53 112.408L992.45 178.193L1006.74 202.981H929.61Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.65 -41.1978H1308.63L1324.56 -13.7809L1327.42 -8.86787L1332.94 0.63502L1361.27 49.3749L1379.59 80.9026H1459.79L1385.65 -41.1978Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.5 -41.1978L1158.04 80.9026H1238.25L1256.41 49.3749L1294.34 -16.3989L1308.63 -41.1978H1231.5Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.77 202.981L1299.31 80.9026H1379.52L1397.68 112.408L1435.61 178.193L1449.9 202.981H1372.77Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6703 447.159H-29.3497L-13.4197 419.753L-10.5597 414.84L-5.03973 405.338L23.2903 356.598L41.6003 325.07H121.81L47.6703 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M349.55 202.981H272.53L288.46 230.398L291.32 235.311L296.85 244.813L325.17 293.553L343.49 325.07H423.7L349.55 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.4 202.981L121.94 325.07H202.15L220.32 293.553L258.24 227.78L272.53 202.981H195.4Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M490.82 447.159H413.8L429.73 419.754L432.59 414.84L438.12 405.338L466.44 356.598L484.76 325.07H564.97L490.82 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336.67 447.159L263.21 325.07H343.42L361.59 356.598L399.51 422.372L413.8 447.159H336.67Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M792.71 202.981H715.69L731.62 230.398L734.48 235.311L740 244.813L768.33 293.553L786.65 325.07H866.85L792.71 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M638.561 202.981L565.101 325.07H645.311L663.481 293.553L701.401 227.78L715.691 202.981H638.561Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M933.98 447.159H856.96L872.89 419.753L875.75 414.84L881.27 405.338L909.6 356.598L927.92 325.07H1008.12L933.98 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M779.83 447.159L706.37 325.07H786.58L804.75 356.598L842.67 422.371L856.96 447.159H779.83Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.86 202.981H1158.85L1174.78 230.398L1177.63 235.311L1183.16 244.813L1211.48 293.553L1229.8 325.07H1310.01L1235.86 202.981Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.71 202.981L1008.26 325.07H1088.46L1106.63 293.553L1144.56 227.78L1158.85 202.981H1081.71Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.13 447.159H1300.12L1316.05 419.753L1318.9 414.84L1324.43 405.338L1352.76 356.598L1371.07 325.07H1451.28L1377.13 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.98 447.159L1149.53 325.07H1229.73L1247.9 356.598L1285.83 422.371L1300.12 447.159H1222.98Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.33 447.159H126.32L142.25 474.576L145.1 479.489L150.63 488.992L178.96 537.732L197.27 569.26H277.48L203.33 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1902 447.159L-24.2698 569.26H55.9302L74.1002 537.732L112.03 471.958L126.32 447.159H49.1902Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M344.61 691.349H267.59L283.52 663.932L286.38 659.019L291.9 649.516L320.23 600.776L338.54 569.26H418.75L344.61 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M190.46 691.349L117 569.26H197.2L215.37 600.776L253.3 666.561L267.59 691.349H190.46Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M646.491 447.159H569.471L585.401 474.576L588.261 479.489L593.781 488.992L622.111 537.732L640.431 569.259H720.641L646.491 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M492.34 447.159L418.88 569.259H499.09L517.26 537.732L555.18 471.958L569.47 447.159H492.34Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M787.76 691.349H710.74L726.67 663.932L729.53 659.019L735.05 649.516L763.38 600.776L781.7 569.26H861.91L787.76 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M633.61 691.349L560.15 569.26H640.36L658.53 600.776L696.45 666.561L710.74 691.349H633.61Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.65 447.159H1012.63L1028.56 474.576L1031.42 479.489L1036.94 488.992L1065.27 537.732L1083.59 569.26H1163.79L1089.65 447.159Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M935.5 447.159L862.04 569.26H942.25L960.41 537.732L998.34 471.958L1012.63 447.159H935.5Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.92 691.349H1153.9L1169.83 663.932L1172.69 659.019L1178.21 649.516L1206.54 600.776L1224.86 569.26H1305.06L1230.92 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.77 691.349L1003.31 569.26H1083.52L1101.68 600.776L1139.61 666.561L1153.9 691.349H1076.77Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.65 447.159L1305.19 569.26H1385.4L1403.57 537.732L1441.49 471.958L1455.79 447.159H1378.65Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7502 691.349H-17.2698L-1.33977 718.754L1.52022 723.667L7.04023 733.181L35.3702 781.921L53.6802 813.438H133.89L59.7502 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M201.02 935.527H124L139.93 908.111L142.79 903.198L148.31 893.695L176.64 844.955L194.95 813.438H275.16L201.02 935.527Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8703 935.527L-26.5897 813.438H53.6103L71.7803 844.955L109.71 910.728L124 935.527H46.8703Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M502.9 691.349H425.88L441.81 718.755L444.67 723.668L450.2 733.182L478.52 781.922L496.84 813.438H577.05L502.9 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M348.75 691.349L275.29 813.438H355.5L373.67 781.921L411.59 716.136L425.88 691.349H348.75Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M644.17 935.527H567.15L583.08 908.11L585.94 903.197L591.47 893.695L619.79 844.955L638.11 813.438H718.32L644.17 935.527Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M490.021 935.527L416.561 813.438H496.771L514.941 844.955L552.861 910.729L567.151 935.527H490.021Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M946.06 691.349H869.04L884.97 718.754L887.83 723.667L893.35 733.181L921.68 781.921L940 813.438H1020.2L946.06 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M791.91 691.349L718.45 813.438H798.66L816.83 781.921L854.75 716.136L869.04 691.349H791.91Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.33 935.527H1010.31L1026.24 908.11L1029.1 903.197L1034.62 893.695L1062.95 844.955L1081.27 813.438H1161.47L1087.33 935.527Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M933.181 935.527L859.721 813.438H939.931L958.101 844.955L996.021 910.729L1010.31 935.527H933.181Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1389.21 691.349H1312.2L1328.13 718.754L1330.98 723.667L1336.51 733.181L1364.84 781.921L1383.15 813.438H1463.36L1389.21 691.349Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.07 691.349L1161.61 813.438H1241.81L1259.98 781.921L1297.9 716.136L1312.2 691.349H1235.07Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.34 935.527L1302.88 813.438H1383.08L1401.25 844.955L1439.17 910.728L1453.47 935.527H1376.34Z",
    stroke: "#A8C956",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxPatterns);
export default __webpack_public_path__ + "static/media/boxPatterns.e7618879f812b948b600c6fd846d901a.svg";
export { ForwardRef as ReactComponent };